import { extend } from "flarum/common/extend";
import PostAdvcommentedNotification from "../../components/PostAdvcommentedNotification";
import UserAdvcommentedNotification from "../../components/UserAdvcommentedNotification";
import NotificationGrid from "flarum/components/NotificationGrid";

export default function () {
  app.notificationComponents.postAdvcommented = PostAdvcommentedNotification;
  app.notificationComponents.userAdvcommented = UserAdvcommentedNotification;
  // todo adv comment notifycations
  extend(NotificationGrid.prototype, "notificationTypes", function (items) {
    items.add("postAdvcommented", {
      name: "postAdvcommented",
      icon: "fas fa-reply",
      label: app.translator.trans(
        "tolyod-advdiscus.forum.settings.notify_post_mentioned_label"
      ),
    });

    items.add("userAdvcommented", {
      name: "userAdvcommented",
      icon: "fas fa-at",
      label: app.translator.trans(
        "tolyod-advdiscus.forum.settings.notify_user_mentioned_label"
      ),
    });
  });
}
